"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var react_1 = __importStar(require("react"));
var dedupe_1 = __importDefault(require("classnames/dedupe"));
var tokens_1 = __importDefault(require("@servicetitan/tokens"));
var Popper_1 = require("../../internal/Popper");
var Tooltip = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, _c = _a.direction, direction = _c === void 0 ? 'top' : _c, _d = _a.el, TooltipElement = _d === void 0 ? 'span' : _d, _e = _a.open, forceOpen = _e === void 0 ? false : _e, text = _a.text, hoverOnly = _a.hoverOnly, tooltipClassName = _a.tooltipClassName, onShow = _a.onShow, onHide = _a.onHide, _f = _a.underline, underline = _f === void 0 ? false : _f, props = __rest(_a, ["children", "className", "direction", "el", "open", "text", "hoverOnly", "tooltipClassName", "onShow", "onHide", "underline"]);
    var _g = react_1.useState(false), open = _g[0], setOpen = _g[1];
    var _h = react_1.useState(false), reveal = _h[0], setReveal = _h[1];
    var _j = react_1.useState(false), touch = _j[0], setTouch = _j[1];
    /* Delay prevents unintentional hover triggering */
    var delay = parseInt(tokens_1.default.durationSlow, 10); // '300ms' -> 300
    react_1.useEffect(function () {
        var timeout = setTimeout(function () {
            setOpen(!!reveal);
            !reveal && (onShow === null || onShow === void 0 ? void 0 : onShow());
            reveal && (onHide === null || onHide === void 0 ? void 0 : onHide());
        }, delay);
        return function () {
            clearTimeout(timeout);
        };
    }, [delay, onHide, onShow, reveal]);
    react_1.useEffect(function () {
        if (touch) {
            setOpen(touch);
            onShow === null || onShow === void 0 ? void 0 : onShow();
            var timeout_1 = setTimeout(function () {
                setOpen(!touch);
                setTouch(!touch);
                onHide === null || onHide === void 0 ? void 0 : onHide();
            }, 1500);
            return function () {
                clearTimeout(timeout_1);
            };
        }
    }, [onHide, onShow, touch]);
    var handleShow = function () {
        setReveal(true);
    };
    var handleHide = function () {
        setReveal(false);
    };
    var handleTouch = function () {
        setTouch(true);
    };
    var getDirection = function () {
        if (direction === 'top')
            return 't';
        if (direction === 'topright')
            return 'tr';
        if (direction === 'topleft')
            return 'tl';
        if (direction === 'bottom')
            return 'b';
        if (direction === 'bottomright')
            return 'br';
        if (direction === 'bottomleft')
            return 'bl';
        if (direction === 'right')
            return 'r';
        if (direction === 'left')
            return 'l';
        return direction;
    };
    var tooltipVisible = text && (open || forceOpen);
    var TooltipClasses = dedupe_1.default('Tooltip', className, {
        'Tooltip--underline': !tooltipVisible && underline,
    });
    var TooltipBodyClasses = dedupe_1.default('Tooltip__body', tooltipClassName, (_b = {},
        _b["Tooltip--" + getDirection()] = getDirection(),
        _b['Tooltip__body--open'] = tooltipVisible,
        _b));
    return (react_1.default.createElement(Popper_1.Popper, __assign({ className: TooltipClasses, width: "auto", autoFlipVertically: true, onMouseEnter: handleShow, onMouseLeave: handleHide, onTouchStart: handleTouch, onFocus: handleShow, onBlur: handleHide, direction: getDirection(), el: TooltipElement, open: tooltipVisible, trigger: children, caret: { show: true } }, props),
        react_1.default.createElement("span", { className: TooltipBodyClasses }, text)));
};
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map